import React, {Fragment, useEffect, useState } from "react";
import axios from "axios";
import {
    MDBTable,
    MDBTableHead,
    MDBTableBody
  } from 'mdb-react-ui-kit';



const Sale = () => {

    return(
        <section class="w-100 p-4 d-flex justify-content-center pb-4">
        <div class="form-outline datepicker" >
          <input type="text" class="form-control" id="exampleDatepicker1" />
          <label for="exampleDatepicker1" class="form-label">Select a date</label>
        </div>
      </section>

      
    );

}

export default Sale;